<template>
  <div>
    <div>
      Bill of Lading
      <a @click.prevent="handleBolClick(false)" href="#">{{row.skOrderNum}}</a>
      [<a @click.prevent="handleBolClick(true)" href="#">bundle</a>]
    </div>
    <div v-for="invoice in row.invoices" :key="invoice.skId" >
      <span>{{invoice.owner || 'Master Invoice'}}</span>
      <span>
        <a @click.prevent="handleInvoiceClick(invoice.skId)" href="#">
          #{{invoice.invoiceRef ? invoice.invoiceRef : invoice.invoiceNum}}
        </a>
      </span>
      <img v-if="invoice.isCustom" class="custom_inv" src="/images/document.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'tdInvoices',
  props: ['row'],
  methods: {
    baseUrl() {
      switch (this.row.type) {
        case 'delivery':
        case 'crossdock':
        case 'crossdock_delivery':
          return `/api/v1/deliveries/${this.row.skId}`;
        case 'pickup':
        case 'crossdock_pickup':
          return `/api/v1/pickups/${this.row.skId}`;
        case 'transfer':
          return `/api/v1/transfers/${this.row.skId}`;
      }
    },
    handleBolClick(bundle) {
      let file = 'invoices.pdf';
      file += bundle ? '?bundle=true' : '';
      window.location = `${this.baseUrl()}/${file}`;
    },
    handleInvoiceClick(id) {
      let file = `${id}.pdf`;
      window.location = `${this.baseUrl()}/invoices/${file}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdInvoices.vue